/* Startseite „Sammeln“: Tabs umschalten und die Leisten in der gewählten Shopify-Sortierung
   holen (Section Rendering API, sections/kjxh-rail.liquid).
   Alle Leisten werden gleich nach dem Laden der Seite im Hintergrund geholt, nicht erst beim
   Tab-Klick. So steht beim Umschalten schon die richtige Reihenfolge da, und nichts sortiert
   sich vor den Augen des Kunden um. Ist eine Leiste beim Eintreffen gerade sichtbar, bleibt
   sie stehen. Schlägt der Abruf fehl, bleibt die serverseitige Leiste. */
(function () {
  'use strict';
  function inView(el) {
    if (el.hidden) return false;
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight);
  }
  function load(root, panel) {
    var sort = root.getAttribute('data-sort');
    if (!sort || sort === 'manual' || panel._kjxhLoaded) return;
    panel._kjxhLoaded = true;
    var rail = panel.querySelector('.kjxh-rail');
    var url = panel.getAttribute('data-url') + '?sort_by=' + encodeURIComponent(sort) + '&section_id=kjxh-rail';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html || !rail || inView(panel)) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-kjxh-rail-src]');
        if (fresh && fresh.children.length) { rail.innerHTML = fresh.innerHTML; rail.scrollLeft = 0; }
      })
      .catch(function () {});
  }
  function init(root) {
    if (root._kjxh) return;
    root._kjxh = true;
    var tabs = [].slice.call(root.querySelectorAll('[role="tab"]'));
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        select(tabs[(i + d + tabs.length) % tabs.length], true);
      });
    });
    root.querySelectorAll('.kjxh-panel').forEach(function (p) { load(root, p); });
  }
  function boot() { document.querySelectorAll('[data-kjxh-shop]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
